import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pic/polkadot-white.png'
import _imports_1 from '@/assets/pic/kusama.token.png'


const _withScopeId = n => (_pushScopeId("data-v-0ca0a999"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-nominate__header-info" }
const _hoisted_2 = { class: "stake-nominate__header-info-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Staking amount", -1))
const _hoisted_4 = {
  key: 0,
  src: _imports_0
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1
}
const _hoisted_6 = { class: "stake-nominate__header-info-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Estimated Returns", -1))
const _hoisted_8 = { class: "stake-nominate__header-info-block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Estimated Yield", -1))

import { selectedNetwork } from "@/stores";
import { Network } from "@/types/network";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-nominate-header-info',
  props: {
  amount: {
    type: Number,
    default: 0,
  },
  returns: {
    type: Number,
    default: 0,
  },
  yield: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {

const currencySymbol = computed(() => {
  if (selectedNetwork.value === Network.Polkadot) {
    return "DOT";
  } else if (selectedNetwork.value === Network.Kusama) {
    return "KSM";
  } else {
    return "WND";
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h5", null, [
        (currencySymbol.value === 'DOT')
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5)),
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.amount)) + " " + _toDisplayString(currencySymbol.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("h5", null, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.returns)) + " " + _toDisplayString(currencySymbol.value), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("h5", null, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.yield)) + "%", 1)
    ])
  ]))
}
}

})